module.exports = __webpack_public_path__ + "static/media/citypark.e6a21650.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/citypark.jpg
// module id = 362
// module chunks = 0